import {format, parse} from "date-fns";
import {MinCoach, TimeSlot} from "./index";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUserCircle} from "@fortawesome/free-solid-svg-icons";

interface Props {
    timeSlot: TimeSlot
    textColor: string
    cardColor: string
    mutedColor: string
    colorBorder: string
    colorMe: string
    colorCs: string
    colorDs: string
    colorCa:string
    colorTa:string
    colorClass: string
}

const ScheduleCard = ({timeSlot, cardColor, textColor, mutedColor, colorBorder, colorMe, colorCs, colorDs, colorCa, colorTa, colorClass} : Props) => {
    const renderCoachImage = (coaches: MinCoach[]) => {
        const coach = coaches.find(c => c.img !== null)
        if (coaches.length === 0 || coach === undefined) {
            return <FontAwesomeIcon  icon={faUserCircle} style={{fontSize: "45px", color: mutedColor}}/>
        }
        return <img alt="coach" src={coach.img}/>
    }
    let start = timeSlot.start
    if (timeSlot.start_time !== null) {
        start =  parse(timeSlot.start_time, "HH:mm:ss", timeSlot.start)
    }
    return (
        <div>
            {/* DESKTOP*/}
            <div className="card card-custom overlay mt-2 pt-2 text-centerl d-none d-md-block rounded-xlll text-left px-6 py-4"
                style={{
                    backgroundColor: cardColor,
                    border: "1.8px solid",
                    borderColor: colorBorder,
                    borderRadius: "25px",
                
                }}>
                <div style={{color: colorClass, fontSize: "12px"}} className="pb-2">{timeSlot.studio_class.name}</div>
                <div className="d-flex align-center align-middle">
                    <div style={{color: textColor, fontSize: "16px"}} className="font-weight-bolder">   {format(start, "h:mm")}</div>
                    <div style={{color: textColor, fontSize: "10px"}} className="font-weight-bolder ml-1 mt-1">   {format(start, "aa")}</div>
                </div>
                <hr className="my-2"/>
                <div style={{color: mutedColor, fontSize: "10px"}} className="m-0 p-0 text-uppercase">{timeSlot.coaches.map(c => c.full_name).join(", ")}</div>
                <div  className="overlay-layer align-items-start justify-content-between pt-1 pr-1">
                </div>
                {/* <p style={{color: textColor}} className="font-weight-bolder">   {format(start, "h:mm aa")}</p> */}
                {/* <div className="symbol symbol-40 symbol-lg-45 symbol-circle mx-auto mt-n3 pb-1">
                    {renderCoachImage(timeSlot.coaches)}
                </div> */}
                {/* <div style={{color: mutedColor}} className="font-size-xs m-0 p-0">{timeSlot.coaches.map(c => c.full_name).join(", ")}</div> */}
            </div>
            
            {/* MOBILE */}
            <div className="card card-custom overlay mt-2 pt-2 text-left d-md-none px-2 py-3" style={{
                    backgroundColor: cardColor,
                    border: "1.8px solid",
                    borderColor: colorBorder,
                    borderRadius: "15px",

                
                }}>
                <div style={{color: colorClass, fontSize: "8px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}} className=" px-0 pt-1">{timeSlot.studio_class.name}</div>
                <div className="d-flex align-middle">
                    <div style={{color: textColor, fontSize: "15px"}} className="font-weight-bolder mt-">   {format(start, "h:mm")}</div>
                    <div style={{color: textColor, fontSize: "10px"}} className="font-weight-bolder ml-1 mt-1">   {format(start, "aa")}</div>
                </div>
                <hr className="my-1"/>

                <div style={{color: mutedColor, fontSize: "6px"}} className="m-0 p-0 text-uppercase">{timeSlot.coaches.map(c => c.full_name).join(", ")}</div>

                <div  className="overlay-layer">
                </div>
            </div>
        </div>
    );
};

export default ScheduleCard;